import { Reducer } from "redux";

import {
    FAQ_INDEX_FETCH_FAILURE,
    FAQ_INDEX_FETCH_REQUEST,
    FAQ_INDEX_FETCH_SUCCESS,
    FaqIndexFetchFailureAction,
    FaqIndexFetchRequestAction,
    FaqIndexFetchSuccessAction,
} from "@/mk2/apps/faq/containers/FaqIndex/FaqIndex.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface ArticlesState {
    articleId: number;
    articlesIds: number[];
    errorMessage: string;
    loadingState: LoadingState;
}

export const initialArticlesState: ArticlesState = {
    articleId: null,
    articlesIds: [],
    errorMessage: null,
    loadingState: LoadingState.INIT,
};

type ArticlesReducerAction =
    | FaqIndexFetchRequestAction
    | FaqIndexFetchSuccessAction
    | FaqIndexFetchFailureAction;

const articlesReducer: Reducer<ArticlesState> = (
    state = initialArticlesState,
    action: ArticlesReducerAction,
) => {
    switch (action.type) {
        case FAQ_INDEX_FETCH_REQUEST:
        case FAQ_INDEX_FETCH_FAILURE:
            return tupdate(state, {
                errorMessage: errorMessage(undefined, action),
                loadingState: loadingState(undefined, action),
            });

        case FAQ_INDEX_FETCH_SUCCESS:
            return tupdate(state, {
                articleId: action.response.result.article,
                articlesIds: action.response.result.articles,
                errorMessage: errorMessage(undefined, action),
                loadingState: loadingState(undefined, action),
            });

        default:
            return state;
    }
};

export const slugAndQueryKey = (articleSlug, query): string => `${articleSlug}:${query || ""}`;

interface BySlugAndQueryState {
    [slugAndQuery: string]: ArticlesState;
}

export interface PageState {
    articles: BySlugAndQueryState;
}

export const initialPageState: PageState = {
    articles: {},
};

declare type FaqIndexReducerAction =
    | FaqIndexFetchRequestAction
    | FaqIndexFetchSuccessAction
    | FaqIndexFetchFailureAction;

export const faqIndexReducer: Reducer<PageState> = (
    state = initialPageState,
    action: FaqIndexReducerAction,
) => {
    switch (action.type) {
        case FAQ_INDEX_FETCH_REQUEST:
        case FAQ_INDEX_FETCH_FAILURE: {
            const key = slugAndQueryKey(action.articleSlug, action.query);
            return tupdate(state, {
                articles: tupdate(state.articles, {
                    [key]: articlesReducer(state.articles[key], action),
                }),
            });
        }

        case FAQ_INDEX_FETCH_SUCCESS: {
            const key = slugAndQueryKey(action.articleSlug, action.query);
            return tupdate(state, {
                articles: tupdate(state.articles, {
                    [key]: articlesReducer(state.articles[key], action),
                }),
            });
        }

        default:
            return state;
    }
};

export default faqIndexReducer;
